import React, {Component} from 'react';

class DeleteAction extends Component {
    render() {
        return (
            <React.Fragment>
                {
                    !this.props.loading ? (
                        <button className="btn btn-danger" onClick={this.props.generate}>Request Remove</button>
                    ) : (
                        <button className="btn btn-danger" disabled>
                            <i className="fa fa-spinner fa-spin"></i>
                            Requesting....
                        </button>
                    )
                }
            </React.Fragment>
        );
    }
}

export default DeleteAction;